import { useSearchParams } from "@solidjs/router";

/**
 * @returns {boolean} True if the URL has the `cog_a` query parameter set to `1`.
 */
export function hasNoEscape(): boolean {
  const [params] = useSearchParams();
  return params.cog_a === "1";
}
